import * as uaParser from 'ua-parser-js'

type OSName = (typeof OS)[keyof typeof OS]

export const DEVICE_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
} as const

export const OS = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  MACOS: 'MACOS',
  WINDOWS: 'WINDOWS',
  LINUX: 'LINUX',
} as const

export const getUserAgent = (userAgent: string) => {
  return uaParser.UAParser(userAgent)
}

export const getOSName = (userAgent: string): OSName => {
  const result = getUserAgent(userAgent)
  const osName = result.os.name

  // ua-parser-js의 다양한 반환값을 우리의 대문자 상수로 정규화
  const normalizedName = osName?.toUpperCase()

  if (normalizedName?.includes('MAC') || normalizedName?.includes('OSX')) {
    return OS.MACOS
  }
  if (normalizedName?.includes('IOS')) {
    return OS.IOS
  }
  if (normalizedName?.includes('ANDROID')) {
    return OS.ANDROID
  }
  if (normalizedName?.includes('WINDOWS')) {
    return OS.WINDOWS
  }
  if (normalizedName?.includes('LINUX')) {
    return OS.LINUX
  }

  return osName as OSName
}

export const isMobile = (userAgent: string) => {
  return uaParser.UAParser(userAgent).device.is('mobile')
}

export const isTablet = (userAgent: string) => {
  return uaParser.UAParser(userAgent).device.is('tablet')
}

export const isDesktop = (userAgent: string) => {
  return !isMobile(userAgent) && !isTablet(userAgent)
}
